import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { handleMobileRedirection } from '../../utils/branchIoUtils';

const loginSignupPaths = ['/login', '/sign-up', '/sign-upAuth'];

const BranchIoRouteListener = () => {
  const location = useLocation();

  useEffect(() => {
    // For the homepage: redirect on any mobile visit (first load or hard reload)
    if (location.pathname === '/') {
      handleMobileRedirection(location.pathname);
      return;
    }

    // Only generate Branch link on hard reload for login/signup pages
    if (loginSignupPaths.includes(location.pathname)) {
      // Check if it's a hard reload (performance.navigation.type === 1)
      if (performance && performance.navigation && performance.navigation.type === 1) {
        handleMobileRedirection(location.pathname);
      }
    }
  }, [location.pathname]);

  return null;
};

export default BranchIoRouteListener;